import brakesIcon from '~/assets/icons/brakes.svg';
import suspension from '~/assets/icons/suspension.svg';
import transmission from '~/assets/icons/transmission.svg';
import wheel from '~/assets/icons/wheel.svg';
import { HandlingMode, TechTuningSection } from '~/shared';

export const techTuningSectionName: Record<TechTuningSection, string> = {
	[TechTuningSection.TRANSMISSION]: 'Трансмиссия',
	[TechTuningSection.SUSPENSION]: 'Подвеска',
	[TechTuningSection.ENGINE]: 'Двигатель',
	[TechTuningSection.BRAKES]: 'Тормозная система',
	[TechTuningSection.TYRES]: 'Сцепление',
};

export const techTuningSectionNameGenitive: Record<TechTuningSection, string> =
	{
		[TechTuningSection.TRANSMISSION]: 'трансмиссии',
		[TechTuningSection.SUSPENSION]: 'подвески',
		[TechTuningSection.ENGINE]: 'двигателя',
		[TechTuningSection.BRAKES]: 'тормозной системы',
		[TechTuningSection.TYRES]: 'сцепления',
	};

export const modeList = [
	{
		name: HandlingMode.Comfort,
		title: 'Comfort',
	},
	{
		name: HandlingMode.Sport,
		title: 'Sport',
	},
	{
		name: HandlingMode.Drift,
		title: 'Drift',
	},
];

export const handlingIcons: Record<TechTuningSection, string> = {
	[TechTuningSection.ENGINE]: transmission,
	[TechTuningSection.TRANSMISSION]: transmission,
	[TechTuningSection.BRAKES]: brakesIcon,
	[TechTuningSection.TYRES]: wheel,
	[TechTuningSection.SUSPENSION]: suspension,
};
